exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_authors_1rEZtA7W031E-jL9mFIrmY {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 40px;\n  margin-block-end: 1em;\n}\n.IA_additionalAuthors_1goxaSeyK_e8YCK3QgMohL {\n  float: left;\n  height: auto;\n  width: 100%;\n  clear: both;\n}", ""]);

// Exports
exports.locals = {
	"IA_authors": "IA_authors_1rEZtA7W031E-jL9mFIrmY",
	"IA_additionalAuthors": "IA_additionalAuthors_1goxaSeyK_e8YCK3QgMohL"
};